import React from 'react'

export const PortalContext = React.createContext(null)

export const PortalProvider = ({ value = {}, children }) => {
  return (
    <PortalContext.Provider value={value}>{children}</PortalContext.Provider>
  )
}

export const usePortal = () => {
  const context = React.useContext(PortalContext)

  return context
}
